import { Component, OnInit, Inject } from '@angular/core';
import { ExportExcelService } from '../../utils/services/export-excel.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-upload-history',
  templateUrl: './upload-history.component.html',
  styleUrls: ['./upload-history.component.css']
})
export class UploadHistoryComponent implements OnInit {
  public exportData: Array<any> = [];
  constructor(
    public exportExcel: ExportExcelService,
    public dialogRef: MatDialogRef<UploadHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() { }

  /**function to upload employee/activity/project*/
  exportToCsv(data, type) {
    this.exportData = [];
    let fileName;
    if (data.length > 0) {
      data.forEach((element, index) => {
        if (element.record.activityType) {
          fileName = 'Activity';
          if (element.record.businessUnit === 'ipdo' || element.record.businessUnit === 'biologics' || element.record.businessUnit === 'chinateam' || element.record.businessUnit == 'aps') {
            this.exportData.push({
              'Sl.No': index + 1,
              'Activity Name': element.record.activityType,
              'Description': element.record.description
            });
          } else if (element.record.businessUnit === 'accenture') {
            this.exportData.push({
              'Sl.No': index + 1,
              'Activity Name': element.record.activityType
            });
          }
        } else if (element.record.Empname) {
          fileName = 'Employee';
          if (element.record.Employment_Status) {
            delete element.record.Employment_Status;
          }
          this.exportData.push(element.record);
        } else if (element.record.businessUnit) {
          fileName = 'Project';
          delete element.record.projectID;
          if (element.record.businessUnit === 'accenture') {
            delete element.record.wbsCode;
          }
          this.exportData.push(element.record);
        } else if (element.record.Team) {
          fileName = 'Employee';
          this.exportData.push(element.record);
        }
      });
      this.exportExcel.JSONToCSVConvertor(this.exportData, fileName, type, true, true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/upload-history/upload-history.component.ts